"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpdateAvailabilityForNewPatients = useUpdateAvailabilityForNewPatients;
var _ = require("./");
function useUpdateAvailabilityForNewPatients(clinicianId) {
  var _useRequest = (0, _.useRequest)((0, _.getClinicianProfileUrl)(clinicianId), {
      onError: function onError() {
        _.toast.warn({
          title: 'Unable to fetch availability settings. Please try again.'
        });
      }
    }),
    loadingClinician = _useRequest.loading,
    _useRequest$data = _useRequest.data,
    clinician = _useRequest$data === void 0 ? {} : _useRequest$data,
    refreshClinician = _useRequest.refresh;
  var _useRequest2 = (0, _.useRequest)({
      url: (0, _.getClinicianProfileUrl)(clinicianId),
      method: 'patch',
      data: {
        acceptingNewPatients: !clinician.acceptingNewPatients
      }
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _.toast.success({
          title: 'Availability settings saved!'
        });
        refreshClinician();
      },
      onError: function onError() {
        _.toast.warn({
          title: 'Unable to save settings. Please try again.'
        });
      }
    }),
    updateAvailabilityPreferences = _useRequest2.run,
    updatingPreferences = _useRequest2.loading;
  var loadingAvailability = loadingClinician || updatingPreferences;
  return {
    available: clinician.acceptingNewPatients,
    loadingAvailability: loadingAvailability,
    updateAvailabilityPreferences: updateAvailabilityPreferences
  };
}